module.exports = __webpack_public_path__ + "static/media/gfg-logo-charcoal.a6916bdf.svg";